import React, { useState } from 'react';
import { useSubmissions } from '../SubmissionsContext';

const CATEGORY_COLOURS = {
  'Birthday':     { bg: '#fff3e0', color: '#e65100' },
  'Achievement':  { bg: '#e8f5e9', color: '#2e7d32' },
  'Outing':       { bg: '#e3f2fd', color: '#1565c0' },
  'Community':    { bg: '#f3e5f5', color: '#6a1b9a' },
  'Home Care':    { bg: '#fce4ec', color: '#c62828' },
  'Magic Moment': { bg: '#fffde7', color: '#f57f17' },
};

const CAT_EMOJI = {
  'Birthday': '🎂', 'Magic Moment': '✨', 'Achievement': '🏆',
  'Outing': '🌳', 'Community': '🤝', 'Home Care': '❤️',
};

const CATEGORIES = ['All', ...Object.keys(CATEGORY_COLOURS)];

const s = {
  page:    { padding: '16px 16px 24px', maxWidth: '540px', margin: '0 auto' },
  heading: { fontSize: '20px', fontWeight: '700', color: '#1a1a2e', marginBottom: '4px' },
  sub:     { fontSize: '13px', color: '#888', marginBottom: '14px' },

  searchRow: { display: 'flex', gap: '8px', marginBottom: '12px' },
  searchInput: {
    flex: 1, padding: '10px 14px', borderRadius: '10px',
    border: '1.5px solid #e8e8ee', fontSize: '14px', outline: 'none',
    background: '#fafafa', boxSizing: 'border-box',
  },

  filterRow: { display: 'flex', gap: '6px', overflowX: 'auto', marginBottom: '18px', paddingBottom: '4px', scrollbarWidth: 'none' },
  chip: {
    padding: '5px 13px', borderRadius: '20px', fontSize: '12px', fontWeight: '600',
    border: '1.5px solid #e8e8ee', background: '#fff', color: '#888',
    cursor: 'pointer', whiteSpace: 'nowrap', flexShrink: 0,
  },
  chipActive: { background: '#DB3267', color: '#fff', border: '1.5px solid #DB3267' },

  card: {
    background: '#fff', borderRadius: '18px', marginBottom: '20px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08), 0 0 0 1px rgba(0,0,0,0.03)',
    overflow: 'hidden',
  },
  photoWrap: { position: 'relative' },
  photo:     { width: '100%', height: '240px', objectFit: 'cover', display: 'block' },
  photoScrim: {
    position: 'absolute', bottom: 0, left: 0, right: 0, height: '110px',
    background: 'linear-gradient(to top, rgba(0,0,0,0.72) 0%, transparent 100%)',
    pointerEvents: 'none',
  },
  photoTitle: {
    position: 'absolute', bottom: '14px', left: '16px', right: '60px',
    color: '#fff', fontSize: '17px', fontWeight: '700', lineHeight: '1.3',
    textShadow: '0 1px 6px rgba(0,0,0,0.5)',
  },
  photoCatBadge: {
    position: 'absolute', top: '12px', right: '12px',
    background: 'rgba(0,0,0,0.38)', backdropFilter: 'blur(12px)', WebkitBackdropFilter: 'blur(12px)',
    color: '#fff', borderRadius: '20px', padding: '4px 11px',
    fontSize: '11px', fontWeight: '700', letterSpacing: '0.3px',
    border: '1px solid rgba(255,255,255,0.18)',
  },
  pinBadge: {
    position: 'absolute', top: '12px', left: '12px',
    background: 'rgba(219,50,103,0.85)', color: '#fff', borderRadius: '20px',
    padding: '3px 10px', fontSize: '11px', fontWeight: '700',
  },
  navBtn: {
    position: 'absolute', top: '50%', transform: 'translateY(-50%)',
    background: 'rgba(0,0,0,0.32)', backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)',
    color: '#fff', border: '1px solid rgba(255,255,255,0.2)',
    width: '34px', height: '34px', borderRadius: '50%', fontSize: '18px',
    display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
  },
  photoDots: { position: 'absolute', bottom: '14px', right: '14px', display: 'flex', gap: '5px' },
  dot:       { width: '5px', height: '5px', borderRadius: '50%', background: 'rgba(255,255,255,0.45)' },
  dotActive: { background: '#fff', width: '14px', borderRadius: '3px' },
  noPhoto: { height: '140px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '44px', position: 'relative' },
  noPhotoCatBadge: { position: 'absolute', top: '12px', right: '12px', borderRadius: '20px', padding: '4px 11px', fontSize: '11px', fontWeight: '700' },
  noPhotoTitle:    { position: 'absolute', bottom: '12px', left: '14px', fontSize: '15px', fontWeight: '700', color: '#1a1a2e' },

  body:    { padding: '14px 16px 16px' },
  caption: { fontSize: '14px', color: '#555', lineHeight: '1.65', marginBottom: '12px' },
  footer:  { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  by:      { fontSize: '12px', color: '#bbb', fontWeight: '500', flex: 1, minWidth: 0 },
  actions: { display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 },
  shiftBadge: {
    fontSize: '11px', color: '#888', background: '#f5f4f8',
    padding: '3px 10px', borderRadius: '10px', fontWeight: '600',
  },
  likeBtn: {
    display: 'flex', alignItems: 'center', gap: '4px',
    background: 'none', border: 'none', cursor: 'pointer',
    fontSize: '12px', fontWeight: '600', color: '#bbb', padding: '4px 6px',
    borderRadius: '8px', transition: 'color 0.15s',
  },
  likeBtnActive: { color: '#DB3267' },
  pinBtn: {
    background: 'none', border: 'none', cursor: 'pointer',
    fontSize: '11px', fontWeight: '600', color: '#bbb', padding: '4px 6px',
    borderRadius: '8px',
  },
  empty:     { textAlign: 'center', padding: '60px 20px', color: '#bbb' },
  emptyIcon: { fontSize: '48px', marginBottom: '12px' },
};

function FeedCard({ sub, user, onToggleLike, onPin, onUnpin }) {
  const [photoIndex, setPhotoIndex] = useState(0);
  const hasPhotos = Array.isArray(sub.photos) && sub.photos.length > 0;
  const catStyle  = CATEGORY_COLOURS[sub.category] || { bg: '#f5f5f5', color: '#555' };
  const isAdmin   = user?.role === 'admin';

  return (
    <div style={s.card}>
      {hasPhotos ? (
        <div style={s.photoWrap}>
          <img src={sub.photos[photoIndex].url} alt="" style={s.photo} />
          <div style={s.photoScrim} />
          <div style={s.photoTitle}>{sub.about}</div>
          <div style={s.photoCatBadge}>{sub.category}</div>
          {sub.isPinned && <div style={s.pinBadge}>📌 Pinned</div>}
          {sub.photos.length > 1 && (
            <>
              <button style={{ ...s.navBtn, left: '10px' }}
                onClick={() => setPhotoIndex(i => (i - 1 + sub.photos.length) % sub.photos.length)}>‹</button>
              <button style={{ ...s.navBtn, right: '10px' }}
                onClick={() => setPhotoIndex(i => (i + 1) % sub.photos.length)}>›</button>
              <div style={s.photoDots}>
                {sub.photos.map((_, i) => (
                  <div key={i} style={{ ...s.dot, ...(i === photoIndex ? s.dotActive : {}) }} />
                ))}
              </div>
            </>
          )}
        </div>
      ) : (
        <div style={{ ...s.noPhoto, background: catStyle.bg }}>
          <span>{CAT_EMOJI[sub.category] || '❤️'}</span>
          {sub.isPinned && <div style={{ ...s.pinBadge, position: 'absolute', top: '12px', left: '12px' }}>📌 Pinned</div>}
          <span style={{ ...s.noPhotoCatBadge, background: 'rgba(255,255,255,0.65)', color: catStyle.color }}>{sub.category}</span>
          <span style={s.noPhotoTitle}>{sub.about}</span>
        </div>
      )}

      <div style={s.body}>
        <div style={s.caption}>{sub.caption}</div>
        <div style={s.footer}>
          <span style={s.by}>Shared by {sub.submittedBy} · {sub.submittedAt.slice(0, 10)}</span>
          <div style={s.actions}>
            <button
              style={{ ...s.likeBtn, ...(sub.userLiked ? s.likeBtnActive : {}) }}
              onClick={() => onToggleLike(sub.id)}
              title={sub.userLiked ? 'Unlike' : 'Like'}
            >
              {sub.userLiked ? '❤️' : '🤍'} {sub.likeCount > 0 ? sub.likeCount : ''}
            </button>
            {isAdmin && (
              <button
                style={s.pinBtn}
                onClick={() => sub.isPinned ? onUnpin(sub.id) : onPin(sub.id)}
                title={sub.isPinned ? 'Unpin' : 'Pin to top'}
              >
                {sub.isPinned ? '📌' : '📍'}
              </button>
            )}
            <span style={s.shiftBadge}>{sub.shift === 'Day' ? '☀️' : '🌙'} {sub.shift}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Feed({ user }) {
  const { submissions, winner, toggleLike, pinSubmission, unpinSubmission } = useSubmissions();
  const [search, setSearch]   = useState('');
  const [catFilter, setCatFilter] = useState('All');

  const allApproved = submissions
    .filter(s => s.status === 'approved' && !s.deletedByUser)
    .sort((a, b) => (b.isPinned ? 1 : 0) - (a.isPinned ? 1 : 0) || b.id - a.id);

  const feed = allApproved.filter(s => {
    const matchesCat = catFilter === 'All' || s.category === catFilter;
    const q = search.toLowerCase().trim();
    const matchesSearch = !q || s.about.toLowerCase().includes(q) || s.caption.toLowerCase().includes(q) || s.submittedBy.toLowerCase().includes(q);
    return matchesCat && matchesSearch;
  });

  const winnerSub = winner ? submissions.find(s => s.id === winner) : null;

  return (
    <div style={s.page}>
      <h1 style={s.heading}>Care Moments Feed</h1>
      <p style={s.sub}>Moments shared by your team</p>

      {/* Search */}
      <div style={s.searchRow}>
        <input
          style={s.searchInput}
          placeholder="Search moments..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
      </div>

      {/* Category filter chips */}
      <div style={s.filterRow}>
        {CATEGORIES.map(cat => (
          <button
            key={cat}
            style={{ ...s.chip, ...(catFilter === cat ? s.chipActive : {}) }}
            onClick={() => setCatFilter(cat)}
          >
            {cat === 'All' ? 'All' : `${CAT_EMOJI[cat] || ''} ${cat}`}
          </button>
        ))}
      </div>

      {winnerSub && catFilter === 'All' && !search && (
        <div style={{
          background: 'linear-gradient(135deg, #DB3267 0%, #9b1f4a 100%)',
          borderRadius: '18px', padding: '20px 22px', marginBottom: '22px', color: '#fff',
          boxShadow: '0 6px 24px rgba(219,50,103,0.32)', position: 'relative', overflow: 'hidden',
        }}>
          <div style={{ position: 'absolute', top: '-20px', right: '-20px', width: '100px', height: '100px', borderRadius: '50%', background: 'rgba(255,255,255,0.07)' }} />
          <div style={{ fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.8px', opacity: 0.75, marginBottom: '8px' }}>🏆 This Month's Winner</div>
          <div style={{ fontSize: '18px', fontWeight: '800', marginBottom: '6px', lineHeight: 1.3 }}>{winnerSub.about}</div>
          <div style={{ fontSize: '13px', opacity: 0.88, lineHeight: 1.6 }}>{winnerSub.caption.slice(0, 120)}{winnerSub.caption.length > 120 ? '...' : ''}</div>
          <div style={{ fontSize: '12px', opacity: 0.65, marginTop: '10px', fontWeight: '500' }}>Submitted by {winnerSub.submittedBy}</div>
        </div>
      )}

      {feed.length === 0 ? (
        <div style={s.empty}>
          <div style={s.emptyIcon}>📸</div>
          <div>{search || catFilter !== 'All' ? 'No moments match your search' : 'No moments shared yet — be the first!'}</div>
        </div>
      ) : (
        feed.map(sub => (
          <FeedCard
            key={sub.id}
            sub={sub}
            user={user}
            onToggleLike={toggleLike}
            onPin={pinSubmission}
            onUnpin={unpinSubmission}
          />
        ))
      )}
    </div>
  );
}
